import clsx from 'clsx';
import { SECTION_BACKGROUND } from './flexibleContent.type';

export const getSectionClasses = (
  background: SECTION_BACKGROUND = 'white',
  type: 'default' | 'small' | 'article' | 'contentHub' = 'default',
): string => clsx('c-se--verticalSpacing', `c-se--${background ?? 'white'}`, `c-se--${type}`);
